module.exports = __webpack_public_path__ + "scroll-down.png?f4a35f99b10fa3f149b7c92c54682e1a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scroll-down.png
// module id = 91
// module chunks = 0